module.exports = __webpack_public_path__ + "img/IMG_3495.af202188.jpg";